import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface AttributesKeyValueTableProps {
  rows: {
    attribute: string;
    value: string;
  }[];
}

export const AttributesKeyValueTable = (
  props: AttributesKeyValueTableProps
) => {
  return (
    <div
      className="max-h-[200px] overflow-auto"
      onMouseDown={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="p-1 font-bold">Attribute</TableHead>
            <TableHead className="p-1 font-bold">Value</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {props.rows.map((row) => (
            <TableRow key={row.attribute}>
              <TableCell className="p-1">{row.attribute}</TableCell>
              <TableCell className="p-1">{row.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
